import React from 'react';
import '@fontsource-variable/vazirmatn/wght.css';
import './style.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const rawBase = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');
const routerProps =
  rawBase && rawBase !== '/' && rawBase !== '.' ? { basename: rawBase } : {};

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter {...routerProps}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
